export default object => ({
  id: object.id,
  name: object.name,
});
